import { IsString, MaxLength } from 'class-validator';

export class PropertyPresentationDto {
  @IsString()
  @MaxLength(50)
  title!: string;

  @IsString()
  @MaxLength(800)
  description!: string;
}
